import React from "react"
import { H1, H2, H3, H4, H5, H6, Section } from 'AtomicComponents'


class HeadingBlock extends React.Component {
  render() {
    const {
      tag='h2',
      value,
      preHeading,
      white,
      margin
    } = this.props
    return (
      <Section padding={margin}>
        { preHeading &&
          <H6 white={white} withDetails>
            {preHeading}
          </H6>
        }
        { tag === 'h1' && <H1 withDetails white={white} {...this.props}>{value}</H1>}
        { tag === 'h2' && <H2 withDetails white={white} {...this.props}>{value}</H2>}
        { tag === 'h3' && <H3 withDetails white={white} {...this.props}>{value}</H3>}
        { tag === 'h4' && <H4 withDetails white={white} {...this.props}>{value}</H4>}
        { tag === 'h5' && <H5 withDetails white={white} {...this.props}>{value}</H5>}
        { tag === 'h6' && <H6 withDetails white={white} {...this.props}>{value}</H6>}
      </Section>
    )
  }
}
export default HeadingBlock



// WEBPACK FOOTER //
// ./src/containers/heading-block/index.jsx